import React from 'react';
import ModuleRoute from 'holocron-module-route';
import ErrorLayout from './components/error/ErrorLayout';
import ErrorPage from './components/error/ErrorPage';
import LOG_EVENTS from './analytics';

const childRoutes = () => [
  <ModuleRoute key="R1">
    <ModuleRoute path="p2p-us/paba" moduleName="axp-peer-payments-pay-any-bank-page-wrapper">
      <ModuleRoute path="intro" title="Introduction" moduleName="axp-peer-payments-pay-any-bank-intro" analytics={LOG_EVENTS.INTRO} />
      <ModuleRoute path="success" title="In" moduleName="axp-peer-payments-pay-any-bank-verification" analytics={LOG_EVENTS.VERIFICATION} />
      <ModuleRoute path="failure" title="In" moduleName="axp-peer-payments-pay-any-bank-verification" analytics={LOG_EVENTS.INTRO} />

    </ModuleRoute>
  </ModuleRoute>,

  <ModuleRoute component={ErrorLayout} key="R6">
    <ModuleRoute
      code="500"
      component={ErrorPage}
      path="*/error"
      status={500}
    />
    <ModuleRoute
      code="404"
      component={ErrorPage}
      path="*"
      status={404}
    />
  </ModuleRoute>,
];

export default childRoutes;
